<template>
  <div class="w-full absolute top-0 left-0 h-full flex items-center justify-center rounded-t-sm" style="background-color: #14141480">
    <div class="bg-white rounded-full">
      <BlTextAv data-testid="coming-soon-text" class="pl-12 pr-12 pt-4 pb-4" :variation="variation" weight="bold">Segera Hadir</BlTextAv>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComingSoon',
  props: {
    variation: {
      type: String,
      default: 'caption-10',
    },
  },
};
</script>
